import ROUTE_META from './publicRouteMeta.json'

const NOT_FOUND_META = {
  title: 'Page not found | x3Algo',
  description: 'The requested x3Algo page could not be found.'
}

export function getPublicRouteMeta(pathname) {
  if (pathname.startsWith('/blog')) {
    return { ...ROUTE_META['/blog'], canonicalPath: pathname }
  }

  const canonicalPath = pathname === '/api-docs'
    ? '/developers'
    : pathname === '/cookie-policy'
      ? '/cookies'
      : pathname
  const meta = ROUTE_META[canonicalPath]
  if (meta) {
    return { ...meta, canonicalPath }
  }

  return { ...NOT_FOUND_META, canonicalPath: null }
}
